var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{attrs:{"src":"/static/img/default_cover.jpg"}}),_c('a',{attrs:{"href":_vm.linkUrl}},[_vm._v("点击跳转app")])])
}
var staticRenderFns = []

export { render, staticRenderFns }